import { all, takeLatest, put, call } from 'redux-saga/effects';

import { AxiosResponse } from 'axios';

import api from 'services/api';

import { ITrackChangeTypes, ITrackChangeError } from './types';

import {
  trackChangeRequest,
  trackChangeSuccess,
  trackChangeFailure,
} from './actions';

type ITrackChangeType = ReturnType<typeof trackChangeRequest>;

export function* tracksChangeRequest({ payload }: ITrackChangeType) {
  try {
    const { called, description, file } = payload;

    const formData = new FormData();
    formData.append('chamado', called);
    formData.append('descricao', String(description));
    for (let i = 0; i < file.length; i += 1) {
      formData.append('anexo', file[i]);
    }

    const { data }: AxiosResponse<ITrackChangeError> = yield call(
      api.post,
      '/portal-conecta/alterar-chamados',
      formData,
    );

    if (data.success === false) {
      const response = {
        status: data.status,
        message: data.message,
        success: data.success,
      };

      yield put(trackChangeFailure(response));
    } else {
      yield put(trackChangeSuccess());
    }
  } catch (err) {
    if (err && err?.response) {
      const response = {
        status: err.response?.status,
        message: err.response?.data.message,
      };

      yield put(trackChangeFailure(response));
      return;
    }

    yield put(
      trackChangeFailure({
        status: 500,
        message: 'Erro interno de servidor',
      }),
    );
  } finally {
    const { handleClickNextStep } = payload;
    handleClickNextStep();
  }
}

export default all([
  takeLatest(ITrackChangeTypes.TRACK_CHANGE_REQUEST, tracksChangeRequest),
]);
